import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=84e22168"
import script from "./MessageModal.vue?vue&type=script&lang=js"
export * from "./MessageModal.vue?vue&type=script&lang=js"
import style0 from "./MessageModal.vue?vue&type=style&index=0&id=84e22168&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports